export const URL = "https://www.sandhyacinehouse.com/webapi/";
export const UPLOADS="https://www.sandhyacinehouse.com/uploads/";
export const EBKEY = "PVMI2Z62ZP";